import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  MONITORING_FEATURE_KEY,
  MonitoringState,
  monitoringAdapter,
} from './monitoring.reducer';

// Lookup the 'Monitoring' feature state managed by NgRx
export const getMonitoringState = createFeatureSelector<MonitoringState>(
  MONITORING_FEATURE_KEY
);

const { selectAll, selectEntities } = monitoringAdapter.getSelectors();

export const getMonitoringStatus = createSelector(
  getMonitoringState,
  (state: MonitoringState) => state.status
);

export const getMonitoringStatusMsg = createSelector(
  getMonitoringState,
  (state: MonitoringState) => state.statusMsg
);
